var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"data":_vm.categoryData,"trigger":"hover","placeholder":"类别"}})}
var staticRenderFns = []

export { render, staticRenderFns }